import React from 'react';

const cardBg = '#111';
const cardBorder = '#1f1f1f';
const cardBorderSelected = 'rgba(220,38,38,0.4)';
const redGradient = '#dc2626';

const TagIcon = ({ size = 6 }) => (
  <svg className={`w-${size} h-${size} text-white opacity-80`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
  </svg>
);

function GenreCard({ item, isSelected, onSelect, onEdit, onDelete, viewMode }) {
  if (viewMode === 'list') {
    return (
      <div className="flex items-center justify-between p-4 rounded-xl transition-all"
        style={{ background: cardBg, border: `1px solid ${isSelected ? cardBorderSelected : cardBorder}` }}>
        <div className="flex items-center gap-4">
          <input type="checkbox" checked={isSelected} onChange={onSelect} className="w-4 h-4 rounded" style={{ accentColor: '#dc2626' }} />
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: redGradient }}>
              <TagIcon size={5} />
            </div>
            <div>
              <h3 className="font-bold text-white text-sm">{item.name}</h3>
              <span className="text-xs" style={{ color: '#6b7280' }}>{item.songs?.length || 0} songs</span>
            </div>
          </div>
        </div>
        <div className="flex gap-2">
          <button onClick={onEdit} className="px-3 py-1.5 rounded-lg text-xs font-medium text-white" style={{ background: '#1a1a1a', border: '1px solid #2a2a2a' }}>Edit</button>
          <button onClick={onDelete} className="px-3 py-1.5 rounded-lg text-xs font-medium" style={{ background: 'rgba(220,38,38,0.1)', color: '#f87171', border: '1px solid rgba(220,38,38,0.2)' }}>Delete</button>
        </div>
      </div>
    );
  }

  return (
    <div className="relative rounded-xl p-5 transition-all"
      style={{ background: cardBg, border: `1px solid ${isSelected ? cardBorderSelected : cardBorder}` }}>
      <div className="absolute top-3 left-3">
        <input type="checkbox" checked={isSelected} onChange={onSelect} className="w-4 h-4 rounded" style={{ accentColor: '#dc2626' }} />
      </div>

      <div className="flex flex-col items-center text-center pt-2">
        <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-4" style={{ background: redGradient }}>
          <TagIcon size={8} />
        </div>

        <h3 className="font-black text-white text-base mb-1">{item.name}</h3>

        {item.description && (
          <p className="text-xs leading-relaxed line-clamp-2 mb-3" style={{ color: '#6b7280' }}>
            {item.description.substring(0, 100)}{item.description.length > 100 && '...'}
          </p>
        )}

        <p className="text-xs mb-5" style={{ color: '#9ca3af' }}>{item.songs?.length || 0} songs</p>

        <div className="flex gap-2 w-full">
          <button onClick={onEdit} className="flex-1 py-2 rounded-lg text-xs font-medium text-white" style={{ background: '#1a1a1a', border: '1px solid #2a2a2a' }}>Edit</button>
          <button onClick={onDelete} className="flex-1 py-2 rounded-lg text-xs font-medium" style={{ background: 'rgba(220,38,38,0.1)', color: '#f87171', border: '1px solid rgba(220,38,38,0.2)' }}>Delete</button>
        </div>
      </div>
    </div>
  );
}

export default GenreCard;